module.exports = __webpack_public_path__ + "static/media/icon-popup-assessment.c9c78207.svg";